import { handleActions } from 'redux-actions';

import { NAME as SELECT_VIDEO } from 'widget/redux/client/actions/select-video';
import { NAMES as VIDEO_PLAYBACK_ACTIONS } from 'widget/redux/client/actions/change-playback-status';

function setSelectedVideoID(state, { payload }) {
  return payload || null;
}

function setVideoIdFromPlayAction(state, { payload }) {
  return payload || state;
}

export default handleActions({
  [SELECT_VIDEO]: setSelectedVideoID,
  [VIDEO_PLAYBACK_ACTIONS.PLAY]: setVideoIdFromPlayAction,
}, null);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/selected-video-id.js